import React from 'react';
import { withTranslation, Trans } from 'react-i18next';
import * as styles from "../tanks.module.scss";

class ExtendedIo extends React.Component {
    constructor(props) {
        super(props);
        const state = Object.assign({}, props.io);
        this.state = state;

        this.onChange = this.onChange.bind(this);
        this.updateData = this.updateData.bind(this);
        this.renderIoTypeName = this.renderIoTypeName.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        return Object.assign({}, props.io);
        //if (state.item !== props.item)
        //    return Object.assign({}, props.io );
        //else {
        //    return null;
        //}
    }

    onChange(propName, value) {
        const state = this.state;
        state[propName] = value;
        this.setState(state);
        this.updateData();
    }

    updateData() {
        this.props.changed(this.state);
    }

    renderIoTypeName() {
        switch (this.props.ioTypeName) {
        case "WatterLevelHeight":
            return this.props.i18n.t("ExtendedIo.watterLevelHeightIoName");
        case "WatterLevelVolume":
            return this.props.i18n.t("ExtendedIo.watterLevelVolumeIoName");
        case "ProductLevelHeight":
            return this.props.i18n.t("ExtendedIo.productLevelHeightIoName");
        case "ProducLevelVolume":
            return this.props.i18n.t("ExtendedIo.producLevelVolumeIoName");
        case "Temperature":
            return this.props.i18n.t("ExtendedIo.temperatureIoName");
        case "Density":
            return this.props.i18n.t("ExtendedIo.densityIoName");
        case "Pressure":
            return this.props.i18n.t("ExtendedIo.pressureIoName");
        case "Weight":
            return this.props.i18n.t("ExtendedIo.weightIoName");
        case "WatterLevelHeightQuality":
            return this.props.i18n.t("ExtendedIo.watterLevelHeightIoQualityName");
        case "WatterLevelVolumeQuality":
            return this.props.i18n.t("ExtendedIo.watterLevelVolumeIoQualityName");
        case "ProductLevelHeightQuality":
            return this.props.i18n.t("ExtendedIo.productLevelHeightIoQualityName");
        case "ProducLevelVolumeQuality":
            return this.props.i18n.t("ExtendedIo.producLevelVolumeIoQualityName");
        case "TemperatureQuality":
            return this.props.i18n.t("ExtendedIo.temperatureIoQualityName");
        case "DensityQuality":
            return this.props.i18n.t("ExtendedIo.densityIoQualityName");
        case "PressureQuality":
            return this.props.i18n.t("ExtendedIo.pressureIoQualityName");
        case "WeightQuality":
            return this.props.i18n.t("ExtendedIo.weightIoQualityName");

        default:
            return "";
        }
    }

    renderInput(dataType, propName) {
        switch (dataType) {
            case "int":
                return <input type="number" step="1" value={this.state[propName]} onChange={(e) => this.onChange(propName, e.target.value)}/>;
            case "float":
                return <input type="number" step="0.01" value={this.state[propName]} onChange={(e) => this.onChange(propName, e.target.value)}/>;
            case "string":
                return <input type="text" value={this.state[propName]} onChange={(e) => this.onChange(propName, e.target.value)}/>;
            
            default:
                return <div></div>;
        }
    }

    renderIoDataTypeName(dataType) {
        switch (dataType) {
        case "int":
            return <Trans>ExtendedIo.intType</Trans>;
        case "float":
            return <Trans>ExtendedIo.floatType</Trans>;
        case "string":
            return <Trans>ExtendedIo.string</Trans>;

        default:
            return <div></div>;
        }
    }

    render() {
        return (
            <div>
                <div className="inline">
                    <div style={{marginLeft: "5%"}}><span><Trans>ExtendedIo.ioType</Trans></span><span>:&emsp;</span><span>{this.renderIoTypeName()}</span></div>
                </div>
                <div className="flex margin10 marginRight20 marginTop30">
                    <div>
                        <div className="inline">
                            <label><Trans>ExtendedIo.ioDataType</Trans></label>
                            <select value={this.state.dataType} onChange={(e) => {
                                this.onChange("dataType", e.target.value);
                            }}>
                                {
                                    this.props.ioDataTypes &&
                                    this.props.ioDataTypes.map((item, index) =>
                                        (
                                            <option className="select_option" key={index} value={item}>
                                                {item}</option>
                                        )
                                    )
                                }
                            </select>
                        </div>
                        <div className="inline">
                            <label><Trans>ExtendedIo.ioAddress</Trans></label>
                            <input type="number" value={this.state.ioAddress}
                                onChange={(e) => this.onChange("ioAddress", e.target.value)} />
                        </div>
                        <div className="inline">
                            <label><Trans>ExtendedIo.offset</Trans></label>
                            <input type="number" step="0.01" value={this.state.offset}
                                onChange={(e) => this.onChange("offset", e.target.value)} />
                        </div>
                        <div className="inline">
                            <label><Trans>ExtendedIo.ratio</Trans></label>
                            <input type="number" step="0.01" value={this.state.ratio}
                                   onChange={(e) => this.onChange("ratio", e.target.value)} />
                        </div>
                        <div className="inline">
                            <label><Trans>ExtendedIo.dataDelta</Trans></label>
                            {this.renderInput(this.state.dataType, "dataDelta")}
                        </div>
                    </div>
                    <div>
                        <div className="inline">
                            <label><Trans>ExtendedIo.defaultValue</Trans></label>
                            {this.renderInput(this.state.dataType, "defaultValue")}
                        </div>
                        <div className="inline">
                            <label><Trans>ExtendedIo.ioDataAction</Trans></label>
                            <select value={this.state.ioDataActionId} onChange={(e) => {
                                this.onChange("ioDataActionId", e.target.value);
                            }}>
                                {
                                    this.props.ioActionTypes &&
                                    this.props.ioActionTypes.map((item, index) =>
                                        (
                                            <option className="select_option" key={index} value={item.ioDataActionId}>
                                                {item.actionName}</option>
                                        )
                                    )
                                }
                            </select>
                        </div>
                        <div className="inline">
                            <label><Trans>ExtendedIo.ioDataActionParam</Trans></label>
                            <input type="text" value={this.state.ioDataActionParam}
                                onChange={(e) => this.onChange("ioDataActionParam", e.target.value)} />
                        </div>
                    </div>
                    {this.props.canBeEdit && 
                        <div style={{ position: "absolute", top: "5px", right: "5px" }}>
                        <button className={styles.remove_io_button} onClick={(e) => {
                            e.preventDefault();
                            this.props.removeIoAction(this.props.io);
                        }}></button>
                    </div>
                    }
                </div>
            </div>
            
        );
    }
}

export default (withTranslation('translantions')(ExtendedIo));